<template>
    <div class="form">
        <h4 class="step-title">
            <label for="VehicleMake">Vehicle Make</label>
        </h4>
        <ValidationObserver v-slot="{ errors, handleSubmit }" @submit.prevent>
            <div class="step-content d-flex flex-column align-items-center">
                <scrollable-button-list v-bind:items="makes" v-bind:onclick="complete" v-if="makes.length > 0"/>
                <div class="step-item" v-if="makes.length == 0">
                    <ValidationProvider mode="eager" vid="vehicleMake" name="Vehicle make" rules="required">
                        <input id="vehicleMakeText" class="form-control" type="text" v-on:keyup.enter="enterKeyup" v-model="vehicle.make">
                    </ValidationProvider>
                </div>
                <div class="step-item" v-if="errors['vehicleMake'] && errors['vehicleMake'].length > 0">
                    <div class="alert alert-danger">{{ errors["vehicleMake"][0] }}</div>
                </div>
                <div class="step-item" v-if="makes.length == 0">
                    <button class="btn step-btn" ref="complete" v-on:click="handleSubmit(complete)">Continue</button>
                </div>
            </div>
        </ValidationObserver>
    </div>
</template>

<script>
    import ScrollableButtonList from "./shared/ScrollableButtonList.vue"
    import { extend } from "vee-validate";
    import { ValidationProvider, ValidationObserver } from 'vee-validate';
    import { required } from "vee-validate/dist/rules";

    extend("required", {
        ...required,
        message: "{_field_} is required."
    });

    export default {
        name: "VehicleMake",
        components: {
            ScrollableButtonList,
            ValidationProvider,
            ValidationObserver
        },
        props: {
            lead: Object
        },
        data: function() {
            return {
                makes: []
            }
        },
        created: function() {
            this.loadMakes();
        },
        computed: {
            vehicle: function () {
                return this.lead.vehicles[this.lead.vehicles.length-1];
            }
        },
        methods: {
            loadMakes: function() {
                if (typeof window.AvengeDigitalWidgetYearMakeModelTrims !== "undefined") {

                    var makes = this.makes;
                    var makesObject = window.AvengeDigitalWidgetYearMakeModelTrims[this.vehicle.year];

                    Object.keys(makesObject).forEach(function(key) {
                        makes.push({ text: key, value: key });
                    });
                }
            },
            enterKeyup: function() {
                this.$refs.complete.click();
            },
            complete: function(vehicleMake) {
                if (vehicleMake) {
                    this.vehicle.make = vehicleMake;
                }

                this.$emit("complete", this.$options.name, this.vehicle.make);
            }
        }
    }
</script>
